import styled from 'styled-components';

import buttonStyles from './buttonStyles';

const A = styled.a`${buttonStyles}`;

export default A;
